import React from 'react';

import { CreateOptionButtonProps } from '@/shared/components/atoms/SelectField/ISelectField';
import { Typography } from '@/shared/components/atoms/Typography';

import Plus from '~/images/shared/Plus.svg';

const CreateOptionButton: React.FC<CreateOptionButtonProps> = ({
  onClick,
  title,
  subTitle,
}) => {
  return (
    <div
      className='mx-12 mb-4 flex cursor-pointer items-center gap-8 border-b-xs border-b-neutralVariant-90 py-16'
      onClick={onClick}
    >
      <div className='flex h-24 w-24 items-center justify-center rounded-full bg-blue-100 text-primary-400'>
        <Plus width='14' height='14' />
      </div>
      <Typography weight='semiBold' className='text-primary-default'>
        {title}
        {subTitle && (
          <Typography className='block text-surface-10'>{subTitle}</Typography>
        )}
      </Typography>
    </div>
  );
};

export default CreateOptionButton;
